export default __webpack_public_path__ + "static/3-90c6e6b990199cf106497dc1c6d84c2f.jpeg";